import React from 'react';
import clsx from 'clsx';
import { AImage } from '../../atoms/AImage/index';
import { AScrimGradient } from '../../atoms/AScrimGradient/index';
import { MLogoContainer } from '../../molecules/MLogoContainer/index';
import { MTextBlockSimple } from '../../molecules/MTextBlockSimple/index';
import { MButton } from '../../molecules/MButton/index';
import { MPhotoCaption } from '../../molecules/MPhotoCaption/index';
import { MSlot } from '../../molecules/MSlot/index';
import * as Styled from './OBannerLayered.styles';
import type { OBannerLayeredProps } from './OBannerLayered.types';
import { AHeaderSize, AHeaderTag } from '../../atoms/AHeader';

const COMPONENT_NAME = 'o-mi-web-ui-kit-OBannerLayered';
const TEST_ID = 'mi-web-ui-kit-OBannerLayered';

export const OBannerLayered: React.FC<OBannerLayeredProps> = ({
  photoCaption = false,
  logo = false,
  cta = false,
  secondaryCta = false,
  aImage,
  aScrimGradient,
  mLogoContainer,
  mTextBlockSimple,
  mButton,
  mButton2,
  mPhotoCaption,
  className,
  cqPath,
  ...rest
}) => {
  const containerClasses = clsx('o-banner-layered', className);

  const { aBody = {}, aEyebrow = {}, aHeader = {} } = mTextBlockSimple ?? {};

  const modifiedMTextBlockSimple = {
    bodyText: aBody.bodyText ?? '',
    eyebrowText: aEyebrow.eyebrowText ?? '',
    headerText: aHeader.text ?? '',
    headerSize: aHeader.size as AHeaderSize,
    headerTag: aHeader.headerTag as AHeaderTag,
  };

  return (
    <Styled.Container className={containerClasses} data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      <Styled.ImageWrapper>
        {aImage && <AImage {...aImage} />}
        {aScrimGradient && <AScrimGradient {...aScrimGradient} />}
      </Styled.ImageWrapper>

      <Styled.ContentWrapper>
        {logo && mLogoContainer && (
          <Styled.LogoWrapper>
            <MLogoContainer {...mLogoContainer} />
          </Styled.LogoWrapper>
        )}

        {mTextBlockSimple && (
          <Styled.TextBlockWrapper>
            <MTextBlockSimple {...modifiedMTextBlockSimple} />
          </Styled.TextBlockWrapper>
        )}

        {(cta || secondaryCta) && (
          <Styled.ButtonWrapper>
            {cta && mButton && <MButton {...mButton} />}
            {secondaryCta && mButton2 && <MButton {...mButton2} />}
          </Styled.ButtonWrapper>
        )}

        {photoCaption && mPhotoCaption && (
          <Styled.PhotoCaptionWrapper>
            <MPhotoCaption {...mPhotoCaption} />
          </Styled.PhotoCaptionWrapper>
        )}
      </Styled.ContentWrapper>

      {cqPath && (
        <>
          <MSlot pagePath={cqPath} itemPath="metaNames" />
          <MSlot pagePath={cqPath} itemPath="metaProperties" />
        </>
      )}
    </Styled.Container>
  );
};
